import React from "react";
import fallBackImage from '../Assests/images/placeholderimage.jpg'

export default function StudentPerformance({ top, need, loader }) {
  return (
    <div className="bg-white rounded-2xl shadow p-5 h-[475px] overflow-y-auto pr-2 scrollbar-hide">
      <h2 className="text-lg font-semibold text-gray-700 mb-4">
        Student Performance
      </h2>

      {/* Top Performers */}
      <div>
        <h3 className="text-green-600 font-medium text-sm mb-2">↑ Top Performers</h3>
        {loader ?
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-primary-600"></div>
          </div>
          :
          (top && top.length > 0) ? top.map((student) => (
            <div key={student.id} className="flex items-center justify-between py-3 mb-3">
              <div className="flex items-center gap-3 w-80">
                <img src={student.profile_pic || fallBackImage} alt={student.student} className="w-8 h-8 rounded-full"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = fallBackImage;
                  }}
                />
                <span className="text-gray-700 font-medium">{student.student}</span>
              </div>
              <div className="flex-1 ml-4">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-green-500 h-2 rounded-full"
                    style={{ width: `${student.score}%` }}
                  ></div>
                </div>
                <span className="text-sm text-gray-500">{student.score}%</span>
              </div>
            </div>
          )) :
            <div className="text-center">
              <p className="text-gray-400 text-sl">There are currently no top performers.</p>
            </div>
        }
      </div>

      {/* Needs Attention */}
      <div className="mt-6">
        <h3 className="text-orange-600 font-medium text-sm mb-2">⚠ Needs Attention</h3>
        {loader ?
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-primary-600"></div>
          </div>
          :
          (need && need.length > 0) ? need.map((student) => (
            <div key={student.id} className="flex items-center justify-between mb-3 py-3">
              <div className="flex items-center gap-3 w-80">
                <img src={student.profile_pic || fallBackImage} alt={student.student} className="w-8 h-8 rounded-full"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = fallBackImage;
                  }}
                />
                <span className="text-gray-700 font-medium">{student.student}</span>
              </div>
              <div className="flex-1 ml-4">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-orange-500 h-2 rounded-full"
                    style={{ width: `${student.score}%` }}
                  ></div>
                </div>
                <span className="text-sm text-gray-500">{student.score}%</span>
              </div>
            </div>
          )) :
            <div className="text-center">
              <p className="text-gray-400 text-sl">There are currently no data.</p>
            </div>
        }
      </div>
    </div>
  );
}
